import React from 'react'

const weatherFormTemplate = (locals) => {
    return (
        <div className="row">
            <div className="col-md-4">
                {locals.inputs.types}
            </div>

            <div className="col-md-2 spark-mar-t-1--lte-sm">
                {locals.inputs.count}
            </div>

            <div className="col-md-6">
                {locals.inputs.airports}
            </div>
        </div>
    )
}

export default weatherFormTemplate


// WEBPACK FOOTER //
// ./src/screens/weather/components/WeatherForm/template.js